import { useEffect } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import {
  FetchManageStaffPageQuery,
  FetchManageStaffPageQueryVariables,
  ManageUsersPage,
} from '@/graphql/generated/graphql';
import { useManageStaffStore } from '../store/useManageStaffStore';
import { FETCH_MANAGE_STAFF_PAGE } from '@/graphql/queries/dashboard/admin';

export const useRoot = () => {
  const { data, error } = useSuspenseQuery<FetchManageStaffPageQuery, FetchManageStaffPageQueryVariables>(
    FETCH_MANAGE_STAFF_PAGE,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    useManageStaffStore.setState({ page: data?.manageUsersPage as ManageUsersPage });
  }, [data]);

  return { page: data?.manageUsersPage ?? null, error };
};
